import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';

@Component({
  selector: 'app-adminnavinvoice',
  templateUrl: './adminnavinvoice.component.html',
  styleUrls: ['./adminnavinvoice.component.css']
})
export class AdminnavinvoiceComponent implements OnInit {

  data : any;

  constructor(private invoiceServices : InvoiceService) { }

  ngOnInit() {
    this.getNavPaidInvoice();
  }

  getNavPaidInvoice()
  {
    this.invoiceServices.getNavPaidInvoice().subscribe(
      (data : any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  syncNavPaidInvoice()
  {
    this.invoiceServices.syncNavPaidInvoice().subscribe(
      (data : any) => {
        alert("data synchronized");
        this.getNavPaidInvoice();
      }
    )
  }

}
